
(function () {
  var form = document.getElementById('MJOrderTrackerForm');
  if (!form) return;

  var messageBox = document.getElementById('MJOrderTrackerMessage');
  var resultBox = document.getElementById('MJOrderTrackerResult');
  var titleEl = document.getElementById('MJOrderTrackerStatusTitle');
  var textEl = document.getElementById('MJOrderTrackerStatusText');
  var etaEl = document.getElementById('MJOrderTrackerEta');
  var badgeEl = document.getElementById('MJOrderTrackerBadge');
  var courierBox = document.getElementById('MJOrderTrackerCourier');
  var courierText = document.getElementById('MJOrderTrackerCourierText');
  var courierLink = document.getElementById('MJOrderTrackerCourierLink');
  var submitButton = document.getElementById('MJOrderTrackerSubmit');

  var steps = ['received', 'processing', 'allocated', 'network', 'uk_stage', 'dispatched'];

  function showMessage(text, isError) {
    messageBox.textContent = text;
    messageBox.hidden = false;
    messageBox.classList.toggle('is-error', !!isError);
  }

  function hideMessage() {
    messageBox.hidden = true;
    messageBox.textContent = '';
    messageBox.classList.remove('is-error');
  }

  function cleanOrderNumber(value) {
    value = String(value || '').trim();
    if (value && value.charAt(0) !== '#') value = '#' + value.replace(/^#+/, '');
    return value;
  }

  function setTimeline(stage) {
    var activeIndex = steps.indexOf(stage);
    if (activeIndex < 0) activeIndex = 0;

    document.querySelectorAll('.mj-order-tracker__step').forEach(function (step) {
      var stepKey = step.getAttribute('data-step');
      var stepIndex = steps.indexOf(stepKey);
      step.classList.remove('is-complete', 'is-active');

      if (stepIndex < activeIndex) step.classList.add('is-complete');
      if (stepIndex === activeIndex) step.classList.add('is-active');
    });
  }

  function renderResult(data) {
    if (!data) return;
    var stage = data.stage || 'received';

    titleEl.textContent = data.status_title || 'Order progress';
    textEl.textContent = data.status_text || 'Your order is progressing through our fulfilment process.';
    etaEl.textContent = data.eta_text || 'Estimated delivery: usually 5–8 business days from order date.';
    badgeEl.textContent = data.badge || (stage === 'dispatched' ? 'Dispatched' : 'In progress');

    setTimeline(stage);

    if (data.tracking_number || data.tracking_url) {
      courierBox.hidden = false;
      courierText.textContent = data.tracking_number ? 'Tracking number: ' + data.tracking_number : 'Courier tracking is available for your order.';
      if (data.tracking_url) {
        courierLink.href = data.tracking_url;
        courierLink.hidden = false;
      } else {
        courierLink.hidden = true;
      }
    } else {
      courierBox.hidden = true;
    }

    resultBox.hidden = false;
  }

  async function lookup(orderNumber, email) {
    var endpoint = window.MJ_ORDER_TRACKER_ENDPOINT || '/apps/mj-order-tracker/lookup';
    var url = new URL(endpoint, window.location.origin);
    url.searchParams.set('order', orderNumber);
    url.searchParams.set('email', email);

    var response = await fetch(url.toString(), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Order lookup failed');
    }

    return response.json();
  }

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    hideMessage();
    resultBox.hidden = true;

    var orderNumber = cleanOrderNumber(document.getElementById('mjOrderNumber').value);
    var email = String(document.getElementById('mjOrderEmail').value || '').trim().toLowerCase();

    if (!orderNumber || !email) {
      showMessage('Please enter your order number and email address.', true);
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Checking...';

    try {
      var data = await lookup(orderNumber, email);

      if (!data || data.found === false) {
        showMessage('We could not find an order matching those details. Please check your order number and email address.', true);
        return;
      }

      renderResult(data);
    } catch (error) {
      showMessage('Order tracking is being connected. Please try again later, or contact us if your order is outside the 5–8 business day delivery window.', true);
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = 'Track order';
    }
  });
})();
